export const products = [
  // Burgerlar
  {
    id: 1,
    name: 'Klassik Mol Go\'shti Burger',
    description: 'Suvli mol go\'shti kotleti, yangi salat, pomidor, piyoz va maxsus sous bilan',
    price: 32000,
    originalPrice: 38000,
    categoryId: 1,
    categoryName: 'Burgerlar',
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400',
    stock: 45,
    unit: 'dona',
    rating: 4.8,
    reviews: 234,
    isFeatured: true,
    isSpicy: false,
    calories: 650,
    ingredients: ['Mol go\'shti kotleti', 'Salat', 'Pomidor', 'Piyoz', 'Maxsus sous']
  },
  {
    id: 2,
    name: 'Pishloqli Burger',
    description: 'Eritilgan cheddar pishloqli klassik mol go\'shti burgeri',
    price: 35000,
    originalPrice: 42000,
    categoryId: 1,
    categoryName: 'Burgerlar',
    image: 'https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=400',
    stock: 38,
    unit: 'dona',
    rating: 4.9,
    reviews: 312,
    isFeatured: true,
    isSpicy: false,
    calories: 720,
    ingredients: ['Mol go\'shti kotleti', 'Cheddar pishloq', 'Salat', 'Pomidor', 'Maxsus sous']
  },
  {
    id: 3,
    name: 'Dabl Burger',
    description: 'Ikki qavat mol go\'shti kotleti, qo\'sh pishloq va bekon bilan',
    price: 48000,
    originalPrice: 55000,
    categoryId: 1,
    categoryName: 'Burgerlar',
    image: 'https://images.unsplash.com/photo-1553979459-d2229ba743d4?w=400',
    stock: 25,
    unit: 'dona',
    rating: 4.9,
    reviews: 189,
    isFeatured: true,
    isSpicy: false,
    calories: 980,
    ingredients: ['2x Mol go\'shti kotleti', 'Qo\'sh pishloq', 'Bekon', 'Salat', 'Maxsus sous']
  },
  {
    id: 4,
    name: 'Tovuqli Burger',
    description: 'Grillda pishirilgan tovuq filesi va yangi sabzavotlar',
    price: 29000,
    originalPrice: 35000,
    categoryId: 1,
    categoryName: 'Burgerlar',
    image: 'https://images.unsplash.com/photo-1550547660-d9450f859349?w=400',
    stock: 42,
    unit: 'dona',
    rating: 4.7,
    reviews: 156,
    isFeatured: false,
    isSpicy: false,
    calories: 520,
    ingredients: ['Tovuq filesi', 'Salat', 'Pomidor', 'Mayonez']
  },
  {
    id: 5,
    name: 'Achchiq Tovuqli Burger',
    description: 'Achchiq qovurilgan tovuq, jalapeno va achchiq sous bilan',
    price: 34000,
    originalPrice: 40000,
    categoryId: 1,
    categoryName: 'Burgerlar',
    image: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=400',
    stock: 30,
    unit: 'dona',
    rating: 4.8,
    reviews: 201,
    isFeatured: true,
    isSpicy: true,
    calories: 680,
    ingredients: ['Achchiq tovuq', 'Jalapeno', 'Salat', 'Achchiq sous']
  },

  // Hot-dog
  {
    id: 6,
    name: 'Klassik Hot-Dog',
    description: 'Mol go\'shti sosiskasi, ketchup, xantal va qarsildoq piyoz bilan',
    price: 18000,
    originalPrice: 22000,
    categoryId: 2,
    categoryName: 'Hot-Dog',
    image: 'https://images.unsplash.com/photo-1610066646336-0f327b6dd50a?w=400',
    stock: 55,
    unit: 'dona',
    rating: 4.6,
    reviews: 178,
    isFeatured: true,
    isSpicy: false,
    calories: 380,
    ingredients: ['Mol go\'shti sosiskasi', 'Ketchup', 'Xantal', 'Qarsildoq piyoz']
  },
  {
    id: 7,
    name: 'Pishloqli Hot-Dog',
    description: 'Eritilgan pishloq va bekon bilan to\'ldirilgan hot-dog',
    price: 22000,
    originalPrice: 27000,
    categoryId: 2,
    categoryName: 'Hot-Dog',
    image: 'https://images.unsplash.com/photo-1610066646336-0f327b6dd50a?w=400',
    stock: 48,
    unit: 'dona',
    rating: 4.7,
    reviews: 145,
    isFeatured: true,
    isSpicy: false,
    calories: 450,
    ingredients: ['Mol go\'shti sosiskasi', 'Cheddar pishloq', 'Bekon', 'Maxsus sous']
  },
  {
    id: 8,
    name: 'Chili Hot-Dog',
    description: 'Uy chili sousi va jalapeno bilan boyitilgan hot-dog',
    price: 25000,
    originalPrice: 30000,
    categoryId: 2,
    categoryName: 'Hot-Dog',
    image: 'https://images.unsplash.com/photo-1610066646336-0f327b6dd50a?w=400',
    stock: 32,
    unit: 'dona',
    rating: 4.8,
    reviews: 167,
    isFeatured: true,
    isSpicy: true,
    calories: 520,
    ingredients: ['Mol go\'shti sosiskasi', 'Uy chili sousi', 'Jalapeno', 'Piyoz']
  },
  {
    id: 9,
    name: 'Bekonli Hot-Dog',
    description: 'Bekon bilan o\'ralgan sosiska va BBQ sous',
    price: 28000,
    originalPrice: 34000,
    categoryId: 2,
    categoryName: 'Hot-Dog',
    image: 'https://images.unsplash.com/photo-1610066646336-0f327b6dd50a?w=400',
    stock: 28,
    unit: 'dona',
    rating: 4.9,
    reviews: 123,
    isFeatured: false,
    isSpicy: false,
    calories: 580,
    ingredients: ['Mol go\'shti sosiskasi', 'Bekon', 'BBQ sous', 'Qarsildoq piyoz']
  },

  // Pitsa
  {
    id: 10,
    name: 'Margherita Pitsa',
    description: 'Klassik italyan pitsasi, pomidor sousi, mozzarella va yangi rayhon',
    price: 45000,
    originalPrice: 55000,
    categoryId: 3,
    categoryName: 'Pitsalar',
    image: 'https://images.unsplash.com/photo-1604068549290-dea0e4a305ca?w=400',
    stock: 25,
    unit: '30 sm',
    rating: 4.8,
    reviews: 234,
    isFeatured: true,
    isSpicy: false,
    calories: 850,
    ingredients: ['Pomidor sousi', 'Mozzarella', 'Yangi rayhon', 'Zaytun moyi']
  },
  {
    id: 11,
    name: 'Pepperoni Pitsa',
    description: 'Pomidor sousi, mozzarella va achchiq pepperoni bo\'laklari',
    price: 55000,
    originalPrice: 65000,
    categoryId: 3,
    categoryName: 'Pitsalar',
    image: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400',
    stock: 32,
    unit: '30 sm',
    rating: 4.9,
    reviews: 312,
    isFeatured: true,
    isSpicy: true,
    calories: 980,
    ingredients: ['Pomidor sousi', 'Mozzarella', 'Pepperoni', 'Oregano']
  },
  {
    id: 12,
    name: 'BBQ Tovuqli Pitsa',
    description: 'BBQ sous, grill tovuq, qizil piyoz va kashnich',
    price: 58000,
    originalPrice: 68000,
    categoryId: 3,
    categoryName: 'Pitsalar',
    image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400',
    stock: 28,
    unit: '30 sm',
    rating: 4.8,
    reviews: 189,
    isFeatured: true,
    isSpicy: false,
    calories: 890,
    ingredients: ['BBQ sous', 'Grill tovuq', 'Qizil piyoz', 'Kashnich', 'Mozzarella']
  },
  {
    id: 13,
    name: 'Vegetarian Pitsa',
    description: 'Yangi qo\'ziqorin, bolgar qalampiri, zaytun, piyoz va makkajo\'xori',
    price: 48000,
    originalPrice: 58000,
    categoryId: 3,
    categoryName: 'Pitsalar',
    image: 'https://images.unsplash.com/photo-1574071318508-1cd2f9f3119f?w=400',
    stock: 35,
    unit: '30 sm',
    rating: 4.7,
    reviews: 156,
    isFeatured: false,
    isSpicy: false,
    calories: 720,
    ingredients: ['Qo\'ziqorin', 'Bolgar qalampiri', 'Zaytun', 'Piyoz', 'Makkajo\'xori', 'Mozzarella']
  },
  {
    id: 14,
    name: 'To\'rt Pishloq Pitsa',
    description: 'Mozzarella, parmezan, gorgonzola va rikotta pishloqlari',
    price: 62000,
    originalPrice: 72000,
    categoryId: 3,
    categoryName: 'Pitsalar',
    image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400',
    stock: 22,
    unit: '30 sm',
    rating: 4.9,
    reviews: 245,
    isFeatured: true,
    isSpicy: false,
    calories: 1050,
    ingredients: ['Mozzarella', 'Parmezan', 'Gorgonzola', 'Rikotta', 'Qaymoq sousi']
  },

  // Lavash
  {
    id: 15,
    name: 'Tovuqli Lavash',
    description: 'Grill tovuq, yangi sabzavotlar va sarimsoq sousi bilan',
    price: 28000,
    originalPrice: 34000,
    categoryId: 4,
    categoryName: 'Lavashlar',
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    stock: 45,
    unit: 'dona',
    rating: 4.8,
    reviews: 278,
    isFeatured: true,
    isSpicy: false,
    calories: 620,
    ingredients: ['Grill tovuq', 'Salat', 'Pomidor', 'Bodring', 'Sarimsoq sousi']
  },
  {
    id: 16,
    name: 'Mol Go\'shtli Lavash',
    description: 'Grill mol go\'shti, sabzavotlar va achchiq sous bilan',
    price: 32000,
    originalPrice: 38000,
    categoryId: 4,
    categoryName: 'Lavashlar',
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    stock: 38,
    unit: 'dona',
    rating: 4.9,
    reviews: 312,
    isFeatured: true,
    isSpicy: true,
    calories: 720,
    ingredients: ['Grill mol go\'shti', 'Salat', 'Pomidor', 'Piyoz', 'Achchiq sous']
  },
  {
    id: 17,
    name: 'Pishloqli Lavash',
    description: 'Eritilgan pishloq aralashmasi va sabzavotlar bilan',
    price: 25000,
    originalPrice: 30000,
    categoryId: 4,
    categoryName: 'Lavashlar',
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    stock: 42,
    unit: 'dona',
    rating: 4.7,
    reviews: 189,
    isFeatured: false,
    isSpicy: false,
    calories: 580,
    ingredients: ['Cheddar', 'Mozzarella', 'Salat', 'Pomidor', 'Maxsus sous']
  },
  {
    id: 18,
    name: 'Miks Lavash',
    description: 'Tovuq va mol go\'shti aralashmasi, qo\'sh pishloq va qo\'sh sous',
    price: 38000,
    originalPrice: 45000,
    categoryId: 4,
    categoryName: 'Lavashlar',
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    stock: 30,
    unit: 'dona',
    rating: 4.9,
    reviews: 267,
    isFeatured: true,
    isSpicy: true,
    calories: 890,
    ingredients: ['Tovuq', 'Mol go\'shti', 'Qo\'sh pishloq', 'Salat', 'Achchiq sous']
  },

  // Ichimliklar
  {
    id: 19,
    name: 'Coca-Cola',
    description: 'Klassik Coca-Cola, 0.5L',
    price: 8000,
    originalPrice: 10000,
    categoryId: 5,
    categoryName: 'Ichimliklar',
    image: 'https://images.unsplash.com/photo-1554866585-cd94860890b7?w=400',
    stock: 120,
    unit: '0.5L',
    rating: 4.8,
    reviews: 456,
    isFeatured: true,
    isSpicy: false,
    calories: 210,
    ingredients: ['Gazlangan suv', 'Shakar', 'Kofein']
  },
  {
    id: 20,
    name: 'Fanta',
    description: 'Apelsinli gazlangan ichimlik, 0.5L',
    price: 8000,
    originalPrice: 10000,
    categoryId: 5,
    categoryName: 'Ichimliklar',
    image: 'https://images.unsplash.com/photo-1624517452488-04869389e4d4?w=400',
    stock: 115,
    unit: '0.5L',
    rating: 4.7,
    reviews: 389,
    isFeatured: true,
    isSpicy: false,
    calories: 200,
    ingredients: ['Gazlangan suv', 'Shakar', 'Apelsin lazzati']
  },
  {
    id: 21,
    name: 'Sprite',
    description: 'Limon-laymli gazlangan ichimlik, 0.5L',
    price: 8000,
    originalPrice: 10000,
    categoryId: 5,
    categoryName: 'Ichimliklar',
    image: 'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?w=400',
    stock: 110,
    unit: '0.5L',
    rating: 4.8,
    reviews: 412,
    isFeatured: false,
    isSpicy: false,
    calories: 190,
    ingredients: ['Gazlangan suv', 'Shakar', 'Limon-laym lazzati']
  },
  {
    id: 22,
    name: 'Yangi Limonad',
    description: 'Yangi siqilgan limon, yalpiz va shakar bilan tayyorlangan',
    price: 12000,
    originalPrice: 15000,
    categoryId: 5,
    categoryName: 'Ichimliklar',
    image: 'https://images.unsplash.com/photo-1621263764928-df1444c5e859?w=400',
    stock: 45,
    unit: '0.4L',
    rating: 4.9,
    reviews: 234,
    isFeatured: true,
    isSpicy: false,
    calories: 150,
    ingredients: ['Yangi limon', 'Shakar', 'Yalpiz', 'Suv']
  },
  {
    id: 23,
    name: 'Milkseyk',
    description: 'Vanilli muzqaymoqli kremli ichimlik',
    price: 18000,
    originalPrice: 22000,
    categoryId: 5,
    categoryName: 'Ichimliklar',
    image: 'https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=400',
    stock: 38,
    unit: '0.4L',
    rating: 4.9,
    reviews: 178,
    isFeatured: true,
    isSpicy: false,
    calories: 450,
    ingredients: ['Vanilli muzqaymoq', 'Sut', 'Qaymoq']
  },

  // Muzqaymoqlar
  {
    id: 24,
    name: 'Vanilli Muzqaymoq',
    description: 'Klassik vanilli muzqaymoq, kremli va yumshoq',
    price: 12000,
    originalPrice: 15000,
    categoryId: 6,
    categoryName: 'Muzqaymoqlar',
    image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400',
    stock: 65,
    unit: 'sharcha',
    rating: 4.8,
    reviews: 345,
    isFeatured: true,
    isSpicy: false,
    calories: 210,
    ingredients: ['Sut', 'Qaymoq', 'Shakar', 'Vanil ekstrakti']
  },
  {
    id: 25,
    name: 'Shokoladli Muzqaymoq',
    description: 'Boy shokoladli muzqaymoq, shokolad bo\'laklari bilan',
    price: 14000,
    originalPrice: 17000,
    categoryId: 6,
    categoryName: 'Muzqaymoqlar',
    image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400',
    stock: 58,
    unit: 'sharcha',
    rating: 4.9,
    reviews: 412,
    isFeatured: true,
    isSpicy: false,
    calories: 250,
    ingredients: ['Sut', 'Qaymoq', 'Kakao', 'Shokolad bo\'laklari']
  },
  {
    id: 26,
    name: 'Qulupnayli Muzqaymoq',
    description: 'Kremli qulupnayli muzqaymoq, qulupnay bo\'laklari bilan',
    price: 14000,
    originalPrice: 17000,
    categoryId: 6,
    categoryName: 'Muzqaymoqlar',
    image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400',
    stock: 52,
    unit: 'sharcha',
    rating: 4.8,
    reviews: 289,
    isFeatured: false,
    isSpicy: false,
    calories: 230,
    ingredients: ['Sut', 'Qaymoq', 'Qulupnay', 'Shakar']
  },
  {
    id: 27,
    name: 'Ikkita Sharcha',
    description: 'O\'zingiz tanlagan ikki xil muzqaymoq',
    price: 22000,
    originalPrice: 26000,
    categoryId: 6,
    categoryName: 'Muzqaymoqlar',
    image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400',
    stock: 40,
    unit: '2 sharcha',
    rating: 4.9,
    reviews: 234,
    isFeatured: true,
    isSpicy: false,
    calories: 420,
    ingredients: ['Tanlangan 2 xil lazzat']
  },
  {
    id: 28,
    name: 'Muzqaymoq Sundae',
    description: 'Vanilli muzqaymoq, shokolad sousi, yong\'oq va olcha bilan',
    price: 25000,
    originalPrice: 30000,
    categoryId: 6,
    categoryName: 'Muzqaymoqlar',
    image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400',
    stock: 35,
    unit: 'dona',
    rating: 4.9,
    reviews: 178,
    isFeatured: true,
    isSpicy: false,
    calories: 480,
    ingredients: ['Vanilli muzqaymoq', 'Shokolad sousi', 'Yong\'oq', 'Olcha']
  }
];

export const getProducts = () => {
  return new Promise((resolve) => {
    setTimeout(() => resolve([...products]), 300);
  });
};

export const getProductById = (id) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const product = products.find(p => p.id === parseInt(id));
      if (product) {
        resolve({ ...product });
      } else {
        reject(new Error('Mahsulot topilmadi'));
      }
    }, 200);
  });
};